module.exports = "https://static.moomoo.com/components/common-redpacket/images/seq_0_59.fb165f9ab4.png";